// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"72":"thanks","171":"webinar"}[chunkId] + "." + {"72":"3c126976","171":"b5f822b0"}[chunkId] + ".js";
};